import "azure-maps-control/dist/atlas.min.css";
import { AzureMapsProvider } from "react-azure-maps";

import GeolocationMapInternal, { GeolocationMapProps } from "./GeolocationMapInternal";

interface Props extends GeolocationMapProps {}

export default function GeolocationMapV2(props: Props) {
  return (
    <AzureMapsProvider>
      <GeolocationMapInternal {...props} />
    </AzureMapsProvider>
  );
}
